import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "admin-page" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = {
  key: 0,
  class: "loading"
}
const _hoisted_4 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_5 = {
  key: 1,
  class: "requests-list"
}
const _hoisted_6 = { class: "request-info" }
const _hoisted_7 = { class: "request-row" }
const _hoisted_8 = { class: "request-value" }
const _hoisted_9 = { class: "request-row" }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 0,
  class: "request-row"
}
const _hoisted_12 = { class: "request-value" }
const _hoisted_13 = { class: "request-row request-meta" }
const _hoisted_14 = {
  key: 0,
  class: "email-sent"
}
const _hoisted_15 = {
  key: 1,
  class: "email-pending"
}
const _hoisted_16 = { class: "request-actions" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "modal modal-small" }
const _hoisted_20 = { class: "modal-actions" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminLayout = _resolveComponent("AdminLayout")!

  return (_openBlock(), _createBlock(_component_AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "page-header" }, [
          _createElementVNode("h1", null, "Запросы на звонок")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: _normalizeClass(["tab", { active: _ctx.activeTab === 'pending' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchTab('pending')))
          }, " Новые (" + _toDisplayString(_ctx.pendingCount) + ") ", 3),
          _createElementVNode("button", {
            class: _normalizeClass(["tab", { active: _ctx.activeTab === 'processed' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchTab('processed')))
          }, " Обработанные (" + _toDisplayString(_ctx.processedCount) + ") ", 3)
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Загрузка..."))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.items.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.activeTab === 'pending' ? 'Нет новых запросов' : 'Нет обработанных запросов'), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: "request-card"
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "request-label" }, "Имя:", -1)),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(item.contact_name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "request-label" }, "Телефон:", -1)),
                            _createElementVNode("a", {
                              href: `tel:${item.phone}`,
                              class: "request-value request-phone"
                            }, _toDisplayString(item.phone), 9, _hoisted_10)
                          ]),
                          (item.comment)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "request-label" }, "Комментарий:", -1)),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(item.comment), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(item.created_at)), 1),
                            (item.email_sent_at)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, "✓ Email отправлен"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_15, "Email в очереди"))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          (_ctx.activeTab === 'pending')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-small btn-success",
                                onClick: ($event: any) => (_ctx.confirmChangeState(item))
                              }, " Связался ", 8, _hoisted_17))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-small btn-warning",
                                onClick: ($event: any) => (_ctx.confirmChangeState(item))
                              }, " Взять снова в работу ", 8, _hoisted_18))
                        ])
                      ]))
                    }), 128))
                  ]))
            ], 64))
      ]),
      (_ctx.showConfirm)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-overlay",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeConfirm && _ctx.closeConfirm(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.confirmTitle), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.confirmMessage), 1),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "btn btn-outline",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeConfirm && _ctx.closeConfirm(...args)))
                }, "Нет"),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  disabled: _ctx.saving,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleChangeState && _ctx.handleChangeState(...args)))
                }, _toDisplayString(_ctx.saving ? "Сохранение..." : "Да"), 9, _hoisted_21)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}